import Lookup from './lookup.js';

export default class PersonType extends Lookup
{
    
}
